const getThStyle = (config = {}) => {
  return {
    letterSpacing: '0.2px',
    fontSize: '0.9rem',
    lineHeight: '22px',
    color: config.color || '#4C4C4D',
    fontWeight: 'normal',
    borderTop: 'none'
  }
}

export const STOCK_TABLE_HEADER = [
  {
    key: ' ',
    thStyle: getThStyle()
  },
  {
    key: 'symbol',
    label: 'TICKER',
    sortable: true,
    thClass: 'text-left',
    thStyle: getThStyle()
  },
  {
    key: 'buy',
    sortable: true,
    label: 'BUY PRICE',
    thStyle: getThStyle(),
    thClass: 'text-right'
  },
  {
    key: 'stop',
    sortable: true,
    label: 'STOP LOSS',
    thStyle: getThStyle(),
    thClass: 'text-right'
  },
  {
    key: 'recommendation',
    sortable: true,
    thClass: 'text-right',
    label: 'RECOMMENDATION',
    thStyle: getThStyle()
  },
  {
    key: 'last',
    sortable: true,
    label: 'LAST PRICE',
    thClass: 'text-right',
    thStyle: getThStyle()
  },
  {
    key: 'change',
    sortable: true,
    label: 'CHANGE',
    thStyle: getThStyle(),
    thClass: 'text-right'
  }
]

export const MAX_WATCH_LIST = 10
export const RECOMMENDATION_OPTIONS = [
  { id: 10, name: 'Buy' },
  { id: 20, name: 'Buy Cover' },
  { id: 30, name: 'To Close' },
  { id: 35, name: 'Buy To Open' },
  { id: 40, name: 'Hold' },
  { id: 50, name: 'Hold Short' },
  { id: 60, name: 'Sell' },
  { id: 70, name: 'Sell Short' },
  { id: 80, name: 'Sell To Open' },
  { id: 90, name: 'Reduce' },
  { id: 100, name: 'Sell Put' }
]
